module.exports = __webpack_public_path__ + "img/reverse-off1.95df48c6.png";